import { useEffect, useRef } from 'react';
import { Tabs } from '@mantine/core';
import classes from './DataLibraryDrawer.module.css';

const DATA_LIBRARY_TABS = [
  { value: 'participants', label: 'Participants' },
  { value: 'participant_midpoint', label: 'Participant Midpoint' },
  { value: 'participant_endpoint', label: 'Participant Endpoint' },
  { value: 'participant_mid_vs_end', label: 'Participant Mid vs End' },
  { value: 'coach_midpoint', label: 'Coach Midpoint' },
  { value: 'coach_endpoint', label: 'Coach Endpoint' },
  { value: 'coach_mid_vs_end', label: 'Coach Mid vs End' },
  { value: 'coach_post_session', label: 'Coach Post Session' },
  { value: 'attendance', label: 'Attendance' },
  { value: 'sessions', label: 'Sessions' },
  { value: 'one_on_ones', label: '1:1s' },
  { value: 'one_on_one_history', label: '1:1 history' },
  { value: 'participant_session_feedback', label: 'Participant Session Feedback' },
] as const;

interface DataLibraryTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export function DataLibraryTabs({ activeTab, onTabChange }: DataLibraryTabsProps) {
  // Below 48em the list is one row that scrolls sideways, so keep the active tab in view.
  const listRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const list = listRef.current;
    if (!list || list.scrollWidth <= list.clientWidth) return;
    list.querySelector('[data-active]')?.scrollIntoView({ inline: 'nearest', block: 'nearest' });
  }, [activeTab]);

  return (
    <Tabs
      value={activeTab}
      onChange={value => value && onTabChange(value)}
      variant="default"
      classNames={{ list: classes.tabsList }}
      styles={{
        tab: {
          fontSize: 13,
          fontWeight: 600,
          padding: '10px 12px',
        },
      }}
    >
      <Tabs.List ref={listRef}>
        {DATA_LIBRARY_TABS.map(tab => (
          <Tabs.Tab key={tab.value} value={tab.value}>
            {tab.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
}
